import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-training-seminar-introductory',
  templateUrl: './training-seminar-introductory.component.html',
  styleUrls: ['./training-seminar-introductory.component.css'],
})
export class TrainingSeminarIntroductoryComponent implements OnInit {
  isLogin: boolean;
  constructor(private router: Router) {}

  ngOnInit(): void {}

  handleRedirect() {
    if (localStorage.getItem('token') && localStorage.getItem('id')) {
      console.log('here1');
      this.router.navigateByUrl('/session/dashboard');
    } else {
      console.log('here');
      this.router.navigateByUrl('/registration');
    }
  }
}
